import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'anatoliapps-angular/services';

import { Region } from 'hakikat/models';
import { API_CONFIG } from 'hakikat/utils';

@Injectable({
  providedIn: 'root'
})
export class RegionService extends ApiService {

  //#region Endpoints
  readonly #REGIONS_ENDPOINT = 'region';
  //#endregion

  //#region Constructor
  constructor() { super(API_CONFIG.apiUrl); }
  //#endregion

  //#region Methods
  public getRegions(isActive?: boolean): Observable<Region[]> {
    return this.get<Region[]>(this.#REGIONS_ENDPOINT, typeof isActive === 'boolean' ? { isActive } : undefined);
  }

  public getRegion(id: string): Observable<Region> {
    return this.get<Region>(`${this.#REGIONS_ENDPOINT}/${id}`);
  }
  //#endregion
  
}
